import React, { useState } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import "./style/finalizeWithLoginStyle.css";
import { logOut } from "../../store/auth/authActions";
import InvoiceButtons from "./InvoiceButtons";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { InputsFinalize } from "./FinalizeNoLogin";
import FormInput from "../../../utils/FormInput";
import { zipCodeValidator } from "../../../utils/formsValidation";
import { Checkbox } from "@mui/material";
import inputsValidation from "../../../messages/inputValidation";

interface IProps {
  onPayTransaction: (value: InputsFinalize) => void;
}

const FinalizeWithLogin: React.FC<IProps> = ({ onPayTransaction }: IProps) => {
  const loginUser = useSelector((state: State) => state.auth.userData);
  const [invoiceType, setInvoiceType] = useState<"noInvoice" | "customerInvoice" | "companyInvoice">("noInvoice");

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<InputsFinalize>({});

  const handleRegistration: SubmitHandler<InputsFinalize> = async (data) => {
    onPayTransaction({ ...data, createInvoice: invoiceType !== "noInvoice" });
  };

  return (
    <div className={"finalize-pay-wrapper"}>
      <h3 className={"pay-login-text"}>
        <span>Zalogowany:</span> {loginUser.email}
      </h3>
      <p className={"logout-text"}>
        Chcesz się wylogować?{" "}
        <a href={""} onClick={() => logOut()}>
          Kliknij tutaj
        </a>
      </p>
      <form onSubmit={handleSubmit(handleRegistration)}>
        <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} />
        {invoiceType !== "noInvoice" && (
          <div className={"inputs-customer-invoice"}>
            <FormInput
              type={"text"}
              name={"companyName"}
              text={"Nazwa firmy"}
              register={{ ...register("companyName", { required: true }) }}
              errors={errors}
              isLabel
            />
            {invoiceType === "companyInvoice" && (
              <FormInput
                type={"text"}
                name={"NIP"}
                text={"NIP"}
                register={{ ...register("NIP", { required: true }) }}
                errors={errors}
                isLabel
              />
            )}
            <FormInput
              type={"text"}
              name={"street"}
              text={"Ulica"}
              register={{ ...register("street", { required: true }) }}
              errors={errors}
              isLabel
            />
            <FormInput
              type={"text"}
              name={"houseNumber"}
              text={"Numer domu"}
              register={{ ...register("houseNumber", { required: true }) }}
              errors={errors}
              isLabel
            />
            <FormInput
              type={"text"}
              name={"flatNumber"}
              text={"Numer mieszkania"}
              register={{ ...register("flatNumber", { required: true }) }}
              errors={errors}
              isLabel
            />
            <FormInput
              type={"text"}
              name={"zipCode"}
              text={"Kod pocztowy"}
              register={{ ...register("zipCode", { ...zipCodeValidator(true) }) }}
              errors={errors}
              isLabel
            />
            <FormInput
              type={"text"}
              name={"city"}
              text={"Miejscowość"}
              register={{ ...register("city", { required: true }) }}
              errors={errors}
              isLabel
            />
          </div>
        )}
        <div className={"divider"} />
        <Controller
          name={"acceptEAktywni"}
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className={"checkbox-div"} id={"checkbox-acceptEAktywni"}>
              <p>
                <Checkbox {...field} className={"checkbox"} />* Akceptuję{" "}
                <a href={"https://eaktywni.pl/polityka-prywatnosci/"}>regulamin</a> serwisu eAktywni.pl.
              </p>
              {errors.acceptEAktywni && (
                <span style={{ marginLeft: "40px" }} className={"input-error"}>
                  *{inputsValidation(errors, "acceptEAktywni")}
                </span>
              )}
            </div>
          )}
        />
        <Controller
          name={"acceptPrivacyPolicy"}
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className={"checkbox-div"} id={"checkbox-acceptPrivacyPolicy"}>
              <p>
                <Checkbox {...field} className={"checkbox"} />* Akceptuję{" "}
                <a href={"https://eaktywni.pl/polityka-prywatnosci/"}>politykę prywatności.</a>
              </p>
              {errors.acceptEAktywni && (
                <span style={{ marginLeft: "40px" }} className={"input-error"}>
                  *{inputsValidation(errors, "acceptPrivacyPolicy")}
                </span>
              )}
            </div>
          )}
        />
        <Controller
          name={"acceptStatute"}
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className={"checkbox-div"} id={"checkbox-acceptStatute"}>
              <p>
                <Checkbox {...field} className={"checkbox"} />* Akceptuję{" "}
                <a href={"https://panel.eaktywni.pl/img/H640GGMIILWACCYIJLO.pdf"}>regulamin</a> serwisu i sklepu
                internetowego.
              </p>
              {errors.acceptEAktywni && (
                <span style={{ marginLeft: "40px" }} className={"input-error"}>
                  *{inputsValidation(errors, "acceptStatute")}
                </span>
              )}
            </div>
          )}
        />
        <input className={"login-button"} type={"submit"} value={"Kupuję i płacę"} />
      </form>
    </div>
  );
};

export default FinalizeWithLogin;
